import React from "react";
import List from "@mui/material/List";
import NavItem from "../helpers/NavItem";

const AdminNavBar = () => {
  return (
    <List>
      <NavItem
        labelText="Users"
        to="users"
      />
      <NavItem
        labelText="Emails"
        to="emails"
      />
      <NavItem
        labelText="Contacts"
        to="contacts"
      />
      <NavItem
        labelText="Images"
        to="images"
      />
      <NavItem
        labelText="Announcements"
        to="announcements"
      />
        <NavItem
        labelText="Operations"
        to="operations"
      />
      <NavItem
        labelText="Search"
        to="search"
      />
    </List>
  );
};

export default AdminNavBar;